/**
 * Telas já redesenhadas no design system novo.
 *
 * Uma lista só, lida pelo menu (selo "Novo") e pelo aviso de primeira visita.
 * Ao redesenhar uma tela, acrescente a rota aqui — é o único lugar a mexer.
 *
 * O selo EXPIRA sozinho: passados `DIAS_DE_DESTAQUE` da data informada, ele
 * some. Sem isso o "Novo" vira permanente e para de significar qualquer coisa.
 */

export const DIAS_DE_DESTAQUE = 45;

const RESUMO_PADRAO =
  'Mesma informação e mesmos controles — o que mudou foi a apresentação: tipografia, cartões, tabelas e espaçamento agora seguem o design system.';

export const TELAS_NOVAS = [
  {
    rota: '/analytics-disruptive',
    desde: '2026-08-03',
    resumo:
      'Os gráficos passaram a usar o tipo que a pergunta deles pede: barras horizontais no lugar de roscas e rótulos girados, uma cor por gráfico e um número em destaque.',
  },
  { rota: '/audit', desde: '2026-08-03', resumo: RESUMO_PADRAO },
  { rota: '/admin/policies', desde: '2026-08-03', resumo: RESUMO_PADRAO },
  { rota: '/approval', desde: '2026-08-03', resumo: RESUMO_PADRAO },
  { rota: '/forms', desde: '2026-08-03', resumo: RESUMO_PADRAO },
  { rota: '/investigation', desde: '2026-08-03', resumo: RESUMO_PADRAO },
  { rota: '/admin/dashboard', desde: '2026-08-03', resumo: RESUMO_PADRAO },
];

/** Só compara a data (sem hora), para o selo não sumir no meio do dia. */
const diasDesde = (iso, hoje) => {
  const [a, m, d] = iso.split('-').map(Number);
  const inicio = Date.UTC(a, m - 1, d);
  const agora = Date.UTC(hoje.getFullYear(), hoje.getMonth(), hoje.getDate());
  return Math.floor((agora - inicio) / 86400000);
};

/** `hoje` é injetável para o comportamento ser testável sem congelar o relógio. */
export const telaNova = (rota, hoje = new Date()) => {
  const achada = TELAS_NOVAS.find((t) => t.rota === rota);
  if (!achada) return null;
  const idade = diasDesde(achada.desde, hoje);
  // idade negativa = data futura; trata como recém-lançada em vez de esconder.
  if (idade > DIAS_DE_DESTAQUE) return null;
  return achada;
};
